import {HStack, Icon} from 'platform/foundation';

import {filledStars} from '../../model/filledStars';

const STARS = [1, 2, 3, 4, 5];

interface RatingStarsProps {
  rating: number | null;
}

export function RatingStars(props: RatingStarsProps) {
  const filled = filledStars(props.rating);
  return (
    <HStack align="center">
      {STARS.map((star) => (
        <Icon
          key={star}
          value="toggle/star"
          size={4}
          color={star <= filled ? 'severity.warning' : 'palettes.neutral.300.100'}
        />
      ))}
    </HStack>
  );
}
